import React from 'react'
import "../../../assets/styles/services.css"

import Egg from "../../../assets/images/desktop/image-transform.jpg"
import Pink_Cup from "../../../assets/images/desktop/image-stand-out.jpg"
import Cherry from "../../../assets/images/desktop/image-graphic-design.jpg"
import Orange from "../../../assets/images/desktop/image-photography.jpg"

const ServicesSection = () => {
	return (
		<div id="services">
			<section id="section-1">
					<div className="row mx-0" style={{ backgroundColor: "#FFFBF8", minHeight: "600px"}}>
							{/* section 1 left */}
							<div className="col col-lg-6 col-md-6 col-12 px-0 left" style={{minHeight: "600px"}}>
									<div className="card" style={{ backgroundColor: "#FFFBF8"}}>
											<div className="card-body">
													<h5 className="card-title">Transform Your Brand</h5>
													<p className="card-text">
															We are a full-service creative agency specializing in helping brands grow fast.
															Engage your clients trough compelling visuals that do most of the marketing for you.
													</p>
													<a href="/#" className="card-link">
															<img src="https://i.ibb.co/TB2DVgK/learnmore.png" alt="learn more" />
													</a>
											</div>
									</div>
							</div>
							{/* section 1 right */}
							<div className="col col-lg-6 col-md-6 col-12 px-0 right" style={{minHeight: "600px"}}>
									<img src={Egg} alt="egg" />
							</div>   
					</div>         
			</section>

			<section id="section-2">
				<div className="row mx-0" style={{minHeight: "600px"}}>
						{/* section 2 left */}
						<div className="col col-lg-6 col-md-6 col-12 px-0 left">
								<img src={Pink_Cup} alt="egg" />
						</div>
						{/* section 2 right */}
						<div className="col col-lg-6 col-md-6 col-12 px-0 right">
								<div className="card">
										<div className="card-body">
												<h5 className="card-title">Stand Out To The Right Audience</h5>
												<p className="card-text">
														Using collaborative formula of designers, researchers, photographers, videographers,
														and copywriters, we'll build and extend your brand in digital places.
												</p>
												<a href="/#" className="card-link">
														<img src="https://i.ibb.co/TB2DVgK/learnmore.png" alt="learn more" />
												</a>
										</div>
								</div>
						</div>   
				</div>         
			</section>

			<section id="section-3">
				<div className="row mx-0">
					{/* Section 3 left */}
					<div className="col col-lg-6 col-md-6 col-12 px-0 left bg-block" style={{ backgroundImage: `url(${Cherry})` }}>
						<div className="bottom-card-wrapper">
							<div className="bottom-card">
								<div className="bottom-card-body">
									<h5 className="bottom-card-title">Graphic Design</h5>
									<p className="bottom-card-text">
										Great design makes you memorable. We deliver artwork that underscores your brand message and captures potential clients’ attention.
									</p>
								</div>
							</div>
						</div>
					</div>

					{/* Section 3 right */}
					<div
						className="col col-lg-6 col-md-6 col-12 px-0 right bg-block"
						style={{ backgroundImage: `url(${Orange})` }}
					>
						<div className="bottom-card-wrapper">
							<div className="bottom-card">
								<div className="bottom-card-body">
										<h5 className="bottom-card-title">Photography</h5>
										<p className="bottom-card-text">
												Increase your credibility by getting the most stunning high-quality photos that improve your business image.
										</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

		</div>
	)
};

export default ServicesSection;